import { Outlet } from "react-router-dom"

const StepperLayout = () => {
    return (
        <div className=""> <Outlet /></div>
    )
}

export default StepperLayout;
